package com.essntl.features.file.ui.imageinfos


sealed interface ImageInfosEvent {
    data class GetImage(
        val id: String,
        val index: Int,
    ) : ImageInfosEvent

    data object DeleteImage : ImageInfosEvent

    data class UpdateImage(val keywords: String) : ImageInfosEvent

    data object ClearState : ImageInfosEvent
}